import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { PaymentsApiOriginService } from './payments-api-origin.service';
import { isSessionCredentialUrl } from './protected-api-url';

@Injectable()
export class BearerInterceptor implements HttpInterceptor {
  public constructor(
    private oAuthService: OAuthService,
    private paymentsApiOrigin: PaymentsApiOriginService,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // BRN-2148: `getAccessToken()` returns null when the storage key is absent, and interpolating
    // that into the template literal produced the literal credential `Bearer null` -- a well-formed
    // but meaningless bearer that protected endpoints reject with 401 rather than treating the
    // request as anonymous. No token means no header at all.
    const accessToken = this.oAuthService.getAccessToken();

    // BRN-2325 (AC12, design L2-2): the credential scope is ORIGIN-parsed -- brain's own API under
    // its path, brain-iam, and the exact payments API origin the tenant config handed down -- so a
    // prefix-similar host receives nothing, and no payments origin known means no widening at all.
    // The payments origin arrives AFTER boot, which is why it is read from the store snapshot here
    // rather than from a bundle constant. The 401 handler deliberately does NOT share this scope any
    // more (see `protected-api-url.ts`): a payments 401 carries the bearer and still says nothing
    // about the BRAIN session.
    if (!accessToken || !isSessionCredentialUrl(request.url, this.paymentsApiOrigin.current)) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          authorization: `Bearer ${accessToken}`,
        },
      }),
    );
  }
}
